import React, {useState} from 'react';
import {Accordion} from '../../Accordion/Accordion';
import {ContentWrapper} from './FolderMetaDataTabAdditional.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {getDateStart, getEffectiveDate} from '../../../utils';
import {RangeDatePicker} from '../../DatePicker/RangeDatePicker';
import {TagPicker} from '../../TagPicker/TagPicker';
import EventEmitter from 'events';
import {
    FolderMetaDataDialog_changeDateValidFrom,
    FolderMetaDataDialog_changeDateValidTo,
    FolderMetaDataDialog_changeTags
} from '../../../init/events';

export interface FolderMetaDataTabAdditionalProps {
    readonly dateValidFrom?: number;
    readonly dateValidTo?: number;
    readonly tags?: string[];
    readonly eventEmitter: EventEmitter;
}

/**
 * @name FolderMetaDataTabAdditional
 * @description
 * The dialog to add the metadata of a newly created folder or edited folder - Metadata Tabs
 */
export const FolderMetaDataTabAdditional: React.VFC<FolderMetaDataTabAdditionalProps> = (props) => {
    const [dateValidFromInput, setDateValidFromInput] = useState<Date>(props.dateValidFrom ? new Date(props.dateValidFrom) : getEffectiveDate());
    const [dateValidToInput, setDateValidToInput] = useState<Date | undefined>(props.dateValidTo ? new Date(props.dateValidTo) : undefined);
    const [tagsInput, setTagsInput] = useState<string[]>(props.tags ?? []);

    const handleDateRange = (dateValidFrom?: Date, dateValidTo?: Date) => {
        if ((dateValidFrom !== undefined) && dateValidFrom) {
            dateValidFrom = getDateStart(dateValidFrom);
            if (dateValidFromInput !== dateValidFrom) {
                setDateValidFromInput(dateValidFrom);
                props.eventEmitter.emit(FolderMetaDataDialog_changeDateValidFrom, dateValidFrom);
            }
        }

        if ((dateValidTo !== undefined) && dateValidTo) {
            dateValidTo = getDateStart(dateValidTo);
            if (dateValidToInput !== dateValidTo) {
                setDateValidToInput(dateValidTo);
                props.eventEmitter.emit(FolderMetaDataDialog_changeDateValidTo, dateValidTo);
            }
        } else {
            setDateValidToInput(undefined);
            props.eventEmitter.emit(FolderMetaDataDialog_changeDateValidTo, undefined);
        }
    };

    const handleTags = (tags: string[]) => {
        setTagsInput(tags);
        props.eventEmitter.emit(FolderMetaDataDialog_changeTags, tags);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            <Accordion accordionHeadline={t('VALIDITY_CAPTION')}
                       startOpen>
                <RangeDatePicker dateFrom={dateValidFromInput}
                                 labelFrom={'DATE_FROM'}
                                 initializeFrom={true}
                                 isClearableFrom={true}
                                 isNullableFrom={false}
                                 dateTo={dateValidToInput}
                                 labelTo={'DATE_TO'}
                                 initializeTo={false}
                                 isClearableTo={true}
                                 isNullableTo={true}
                                 onChange={handleDateRange}/>
            </Accordion>
            <Accordion accordionHeadline={t('CREATE_EDIT_FOLDER_DIALOG_ACCORDION_TITLE_TAGS')}
                       startOpen>
                <TagPicker dataSource={tagsInput}
                           onChange={handleTags}/>
            </Accordion>
        </ContentWrapper>
    );
}